import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//import { fetchSocieties, deleteSociety, createSociety } from '../../features/societies/societiesSlice';
import DataTable from "react-data-table-component";
import { signatoriesColumns } from "./utils/columns";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import SocietyFormModal from "./SocietyFormModal";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { ChevronDown, PlusSquare } from "react-feather";
import CustomPagination from "./customPagination";
import { createSignatory, deleteSignatory, updateSignatory } from "../thunks";
import moment from "moment";
import { documentTypes } from "../../../../utility/helpers";

const SignatoriesTable = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.signatories);
  const compamyPositions = useSelector((state) => state.companyPositions);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [selectedSociety, setSelectedSociety] = useState(null);
  const [currentPage, setCurrentPage] = useState(0)
  const { societies } = useSelector((state) => state.signatories);



  useEffect(() => {
    //dispatch(fetchSocieties());
  }, [dispatch]);

  const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);
  const toggleCreateModal = () => setIsCreateModalOpen(!isCreateModalOpen);

  const toggleFormModal = () => {
    setSelectedSociety(null);
    setIsFormModalOpen(!isFormModalOpen);
  };

  const handleDelete = (id) => {
    setSelectedSociety(list.find((society) => society.id === id));
    toggleDeleteModal();
  };

  const confirmDelete = () => {
    if (selectedSociety) {
      dispatch(deleteSignatory(selectedSociety.id));
    }
    toggleDeleteModal();
  };

  const handleSubmitSociety = (data) => {
    if (selectedSociety) {
      dispatch(updateSignatory({ id: selectedSociety.id, ...data }));
    } else {
      dispatch(createSignatory(data));
    }
    toggleFormModal();
  };

  const handleEdit = (society) => {
    const currentSociety = societies.find( s => s.value === society.societyId)
    let currentPosition = compamyPositions.list.find( s => s.id === society.positionId)
    const currentDocumentType = documentTypes.find( s => s.value === society.identificationTypeId)
    
    currentPosition = {value: currentPosition.id, label: currentPosition.name}

    setSelectedSociety({
      ...society, 
      societyId: 
      currentSociety, positionId: currentPosition,
      birthDate: moment(society.birthDate),
      identificationTypeId: currentDocumentType
    });
    setIsFormModalOpen(true);
  };

  const filteredSocieties = list?.filter((society) =>
    `${society?.firstName?.toLowerCase()} ${society?.lastName?.toLowerCase()}`.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const handlePagination = (page) => {
    setCurrentPage(page.selected);
  };

  return (
    <div>
      <Row className="justify-content-end mx-0">
        <Col className="d-flex justify-content-end mt-1" md="6" sm="12">
          <Button
            onClick={toggleFormModal}
            color="primary"
            className="btn-sm"
          >
            <PlusSquare size={16} />
            <span className={"ms-1"}>Crear Firmante</span>
          </Button>
        </Col>
      </Row>
      <hr />

      <Row className="justify-content-end mx-0">
        <Col
          className="d-flex align-items-center justify-content-end mt-1"
          md="6"
          sm="12"
        >
          <Label className="me-1" for="search-input">
            Buscar por nombre
          </Label>

          <Input
            className="dataTable-filter mb-50"
            type="text"
            bsSize="sm"
            id="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
      </Row>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <div className='react-dataTable'>
          <DataTable
            columns={signatoriesColumns(handleEdit, handleDelete)}
            data={filteredSocieties}
            className='react-dataTable'
            sortIcon={<ChevronDown size={10} />}
            pagination
            highlightOnHover
            pointerOnHover
            responsive
            noHeader
            paginationComponent={() => (
              <CustomPagination
                currentPage={currentPage}
                handlePagination={handlePagination}
                pageCount={Math.ceil(filteredSocieties.length / 20)}
              />
            )}
            paginationDefaultPage={currentPage + 1}
          />
        </div>
      )}
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        toggle={toggleDeleteModal}
        onConfirm={confirmDelete}
        societyName={`${selectedSociety?.firstName} ${selectedSociety?.lastName}` || ""}
      />

      <SocietyFormModal
        isOpen={isFormModalOpen}
        toggle={toggleFormModal}
        onSubmit={handleSubmitSociety}
        initialData={selectedSociety}
      />
    </div>
  );
};

export default SignatoriesTable;
